<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M20 4a2 2 0 0 1 2 2v3.5q0 .4-.5.6a2 2 0 0 0 0 3.8q.5.2.5.6V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3.5q0-.5.5-.6a2 2 0 0 0 0-3.8Q2 9.9 2 9.5V6a2 2 0 0 1 2-2zm-9 9.6L8.3 11 7 12.2l4.2 4.1L17 8.8l-1.5-1.2z"
      clip-rule="evenodd"
    />
  </svg>
</template>
